import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["copyInput", "copy"]

  connect() {
    this.update()
  }

  update() {
    this.copyTarget.textContent = this.copyInputTarget.value
  }
}
